import { Fragment, ReactElement } from 'react';
import ResearchCivilUnionNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union';

const ResearchCivilUnionNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchCivilUnionNotificationCivilStatusShared />
    </Fragment>
  );
};

ResearchCivilUnionNotificationCivilStatusPage.displayName =
  'Research Civil Union Notifications Page component';

export default ResearchCivilUnionNotificationCivilStatusPage;
